import React, { useState } from "react";
import { useCurrentPng } from 'recharts-to-png';
import FileSaver from "file-saver";

import * as XLSX from "xlsx";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
;

export default function ExcelChart() {
    const [data, setData] = useState([]);
    const [getPng, {ref , isLoading} ] = useCurrentPng();

    const handleDownload = async () => {
       
        const png = await getPng();
        console.log("hiiiiiiiiii", png)
        if(png){
            FileSaver.saveAs(png, 'my-chart.png')
        }
    }

    // Handle file upload
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });

            // Get first sheet
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            // Convert sheet to JSON
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            console.log("jsonData--->",jsonData);

            setData(jsonData.slice(0,100));
        };

        reader.readAsBinaryString(file);
    };

    return (
        <div className="p-6" style={{ marginLeft: '300px', }}>
            <h2 className="text-xl font-bold mb-4 mt-2">Excel Data Chart</h2>
            <div className="d-flex align-items-center justify-content-between">
            <input
                type="file"
                accept=".xlsx, .xls, .csv"
                onChange={handleFileUpload}
                className="mb-6"
            />
            
            <button className='chart-download-btn' onClick={handleDownload} disabled={isLoading}>
                {isLoading ? "Generating image" :"Download chart"}
            </button>
            </div> 
            {data.length > 0 && (
                <ResponsiveContainer width="100%" height={400}>
                    <LineChart width={2000} height={2500}  data={data} ref={ref}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="TimeString" /> {/* X-axis column from Excel */}
                        <YAxis 
                        
                        
                        
                        
                        />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="VarValue" stroke="#8884d8" />
                        <Line type="monotone" dataKey="Time_ms" stroke="green" />
                        <Line type="monotone" dataKey="Validity" stroke="red" />
                        
                    </LineChart>
                </ResponsiveContainer>
            )}
        </div>
    );
}



